module.exports = __webpack_public_path__ + "static/media/image_19.ef70cbe8.png";